import { render, staticRenderFns } from "./UserAddressCreate.vue?vue&type=template&id=d2f05262&"
import script from "./UserAddressCreate.vue?vue&type=script&lang=js&"
export * from "./UserAddressCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports